// Vue
import TurbolinksAdapter from 'vue-turbolinks'
import Vue from 'vue/dist/vue.esm'
import store from '../mix/store/store'
import filters from '../mix/helpers/filters'
import CompWrapper from "../mix/CompWrapper"
import Bowser from "bowser"

// filters from '../mix/helpers/filters'
Vue.filter('capitalize', filters.capitalize)
Vue.filter('unSnakeCase', filters.unSnakeCase)

// vue-js-modal
import VModal from 'vue-js-modal'
Vue.use(VModal, {dynamic: true});

// vue globals
Vue.prototype.$browser = window.browser = Bowser
document.dispatchEvent(new Event('init-browser'))
Vue.prototype.$environment = process.env.RAILS_ENV

// Axios
import axios from 'axios'

axios.defaults.headers.common = {
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    'Content-Type': 'application/json',
    'Accept': 'application/json'
}

// AWS SDK configuration
import AWS from 'aws-sdk'
import {awsConfigs} from "../mix/config"
AWS.config.region = awsConfigs.S3VideoRegion;
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: awsConfigs.CognitoIdentityPoolId
});

// Init app
const event = (typeof Turbolinks == 'object' && Turbolinks.supported) ? 'turbolinks:load' : 'DOMContentLoaded'
const initVueMix = () => {
    Array.from(document.getElementsByTagName('comp-wrapper')).map((el) => {
        if (!el.classList.contains('lazy')) {
            new Vue({
                el: el,
                store: store,
                components: {CompWrapper}
            })
        }
    })
}

if (event === 'turbolinks:load') {
    Vue.use(TurbolinksAdapter)
}

document.addEventListener(event, () => {
  initVueMix()
  setInterval(initVueMix, 1000)
})

window.config = {DEFAULT_IMAGE: process.env.DEFAULT_IMAGE }
